// Gets value of the given CSS variable
var getCssVariable = function getCssVariable(cssVariable) {
  var computedStyle = getComputedStyle(document.documentElement);
  return computedStyle.getPropertyValue(cssVariable);
};
// Gets value of the given CSS variable and converts it to number
var getNumericCssVariable = function getNumericCssVariable(cssVariable) {
  var cssVariableString = getCssVariable(cssVariable);
  return parseInt(cssVariableString, 10);
};

export { getCssVariable, getNumericCssVariable };
